import userContact from "../../../../components/userContact/userContact";
import { connect } from "react-redux";
export default connect((state) => ({
  membersAtRiskRawDataLink: state.followUp.nearlyExhaustedToday.raw_data_view_url,
  showDetails: true,
  membersAtRiskNumber: state.followUp.nearlyExhaustedToday.visitors_today_list.length,
  data: state.followUp.nearlyExhaustedToday.visitors_today_list,
  total: state.followUp.nearlyExhaustedToday.total_visitors_today,
  nearlyExhausted: true
}))(userContact);
